import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import useTrainingModule, { generateUrls } from '@hooks/useTrainingModule'

import type { TrainingModuleModel } from '@models/types'

const lessonText = (lesson_count?: number) => {
  if (lesson_count === 1) return 'Lesson'
  return 'Lessons'
}

type TrainingModuleListItemItemProps = {
  trainingModule: TrainingModuleModel,
}

const TrainingModuleListItem = (props: TrainingModuleListItemItemProps) => {
  const { trainingModule } = props

  const {
    callbacks: {
      deleteTrainingModule: deleteFn,
    },
  } = useTrainingModule(trainingModule)

  const { lesson_count, title } = trainingModule

  const { editTrainingModuleUrl } = generateUrls(trainingModule)

  const text = lessonText(lesson_count)

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    strings: { entityName: 'Training Module' },
  }

  return (
    <DashboardModuleListItem
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {lesson_count} {text}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editTrainingModuleUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default TrainingModuleListItem
